module.exports = __webpack_public_path__ + "static/media/Tedman Martinez-Rojas.2f460739.png";